import Fetcher from "../fetcher";
import { parseChargeCallbacks } from "./utils";
import handleValidateResponse from "./handler/validate";
import { callback, withProperties, isPlainObject, noop } from "../utils";
import { DEFAULT_POST_INIT, isJsonResponse, withSharedHeaders } from "../fetcher/utils";
import { USES_CHARGE_VALIDATE, USES_VALIDATE_POLLING } from "./flags";

const $fetcher = withSharedHeaders(Fetcher.one.init(DEFAULT_POST_INIT));

function __getValidateEndpoint__() {
  const usePolling = Boolean(this.flags & USES_VALIDATE_POLLING);
  const useChargeValidate = Boolean(this.flags & USES_CHARGE_VALIDATE);

  const VALIDATE_ENDPOINT = `/flwv3-pug/getpaidx/api/validate${
    String.apply(null, ['charge'].slice(!useChargeValidate))
  }`;

  const endpoint = new URL(VALIDATE_ENDPOINT, process.env.API_BASE_URL);

  if (usePolling === true) {
    endpoint.searchParams.set('use_polling', 1);
  }

  return endpoint;
}

export default function __validate__(data, callbacks) {
  const $this = this;
  let { onBegin, onComplete, onError } = (callbacks = parseChargeCallbacks(callbacks));

  onBegin = callback(onBegin);
  onComplete = callback(onComplete);
  onError = callback(onError, noop /* console.error */);

  const handleResponse = handleValidateResponse.bind(
    withProperties(Object.create(null), { ...callbacks })
  );

  return Promise.resolve($this.$chargeData)
    .then(($chargedata) => {
      onBegin.call($this);

      return $fetcher(__getValidateEndpoint__.call($this), {
        body: JSON.stringify({
          ...(isPlainObject(data) ? data : {}),
          modalauditid: $chargedata.modalauditid,
          PBFPubKey: $chargedata.PBFPubKey
        })
      })
        .then(response => {
          if (isJsonResponse(response)) {
            /* if (response.ok) */return response.json().then(handleResponse);
          }

          return Promise.reject(new Error);
        })
        .catch(onError)
        .finally(onComplete.bind($this));
    });
}
